"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

// Re-renders the server components of the current page on an interval, so an
// open tab keeps showing fresh data. Skips ticks while the tab is hidden.
export default function AutoRefresh({ seconds }: { seconds: number }) {
  const router = useRouter();

  useEffect(() => {
    const id = setInterval(() => {
      if (document.visibilityState === "visible") router.refresh();
    }, seconds * 1000);
    return () => clearInterval(id);
  }, [router, seconds]);

  return null;
}
